import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Icon, { SvgIconName } from "components/components/Icon/Icon";
import { IconSize } from "components/components/Icon/IconWrapper";
import { useErrorContext } from "contexts/ErrorContext";
import React, { useState } from "react";
import { copyText } from "utils/stringHelpers";

import { Container, StyledButton } from "./style";

interface Props {
  value?: string;
  label?: string;
}

const CopyToClipboard: React.FC<Props> = ({ value, label }) => {
  const { registerError } = useErrorContext();
  const [copied, setCopied] = useState<boolean>(false);

  const registerSuccess = (): void => {
    setCopied(true);
  };

  const onClick = (): void => {
    if (value) {
      copyText(value, registerSuccess, registerError);
    }
  };

  if (copied) {
    setTimeout(() => {
      setCopied(false);
    }, 1500);

    return (
      <Container>
        <Icon iconName={faCheck} />
        <span>Copied</span>
      </Container>
    );
  }

  return (
    <Container className="is-link">
      <StyledButton
        ariaLabel={`copy ${label} to clipboard`}
        iconName={SvgIconName.Copy}
        iconSize={IconSize.xSmall}
        buttonText="Copy"
        onClick={onClick}
      />
    </Container>
  );
};

export default CopyToClipboard;
